import * as wsApi from '@auw/api-client';
import type { FileAttachment } from '@auw/workspace-utils';

type AttachmentMeta = {
  file_id?: string;
  name?: string;
  mime_type?: string;
  size?: number;
};

export function buildRemoteAttachment(meta: AttachmentMeta): FileAttachment | null {
  if (!meta.file_id || typeof meta.file_id !== 'string') return null;
  const name = (typeof meta.name === 'string' && meta.name.trim()) || meta.file_id;
  const type = typeof meta.mime_type === 'string' ? meta.mime_type : 'application/octet-stream';
  const size = typeof meta.size === 'number' ? meta.size : 0;
  const remoteUrl = wsApi.getFileServeUrl(meta.file_id);
  const fileObj =
    typeof File !== 'undefined'
      ? new File([], name, { type })
      : ({ name, size: 0, type } as unknown as File);
  return {
    id: meta.file_id,
    name,
    type,
    size,
    previewUrl: undefined,
    file: fileObj,
    remoteUrl,
  };
}

export function parseAttachmentFilesFromMeta(
  metadata?: Record<string, unknown>,
  attachmentIds?: string[],
): FileAttachment[] | undefined {
  const out: FileAttachment[] = [];
  const raw = metadata?.attachment_files;
  if (Array.isArray(raw)) {
    for (const item of raw) {
      if (!item || typeof item !== 'object') continue;
      const built = buildRemoteAttachment(item as AttachmentMeta);
      if (built) out.push(built);
    }
  }
  if (out.length > 0) return out;

  if (Array.isArray(attachmentIds) && attachmentIds.length > 0) {
    for (const fileId of attachmentIds) {
      if (typeof fileId !== 'string' || !fileId.trim()) continue;
      const built = buildRemoteAttachment({ file_id: fileId });
      if (built) out.push(built);
    }
  }
  return out.length > 0 ? out : undefined;
}
